import { render, staticRenderFns } from "./SocialAuth.vue?vue&type=template&id=55ddeaae&scoped=true&"
import script from "./SocialAuth.vue?vue&type=script&lang=js&"
export * from "./SocialAuth.vue?vue&type=script&lang=js&"
import style0 from "./SocialAuth.vue?vue&type=style&index=0&id=55ddeaae&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55ddeaae",
  null
  
)

export default component.exports